export function organizeDataByYears(data) {
  const sortedData = data?.sort((a, b) => a.period - b.period);

  return sortedData;
}
